import { styled } from "@mui/material/styles";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { colors, fonts } from "../../../theme/theme";

export const RootBox = styled(Box)(({ theme }) => ({
  backgroundColor: "rgba(255,255,255, 0.25)",
  borderRadius: "10px",
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
  minWidth: "300px",
}));

export const SidebarTitle = styled(Typography)(({ theme }) => ({
  fontFamily: fonts.gotham,
  fontSize: "18px",
  color: theme.palette.text.primary,
  margin: theme.spacing(1),
  borderBottom: `1px solid ${colors.lightBorder}`,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const ScrollableBox = styled(Box)(({ theme }) => ({
  overflowY: "auto",
  height: "72.5vh",
  "&::-webkit-scrollbar": { width: "8px" },
  "&::-webkit-scrollbar-track": {
    background: "#f1f1f1",
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#4b5146",
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#d4a017",
  },
  [theme.breakpoints.down(750)]: {
    maxHeight: "30vh",
  },
}));

export const PartTitle = styled(Typography)(({ theme }) => ({
  fontFamily: fonts.quicksand,
  color: theme.palette.text.primary,
  fontSize: "18px",
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const IntroductionLink = styled(Typography)(({ theme }) => ({
  fontFamily: fonts.quicksand,
  color: theme.palette.text.primary,
  fontSize: "18px",
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  marginBottom: theme.spacing(1),
  "&:hover": {
    cursor: "pointer",
    textDecoration: "underline",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const LessonTitleLink = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  fontFamily: fonts.quicksand,
  color: theme.palette.text.primary,
  fontSize: "20px",
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  "&:hover": {
    cursor: "pointer",
    textDecoration: "underline",
  },
}));

export const StyledAccordion = styled(Accordion, {
  shouldForwardProp: (prop) => !["$expanded", "$isFirst"].includes(prop),
})(({ theme, $expanded, $isFirst }) => ({
  boxShadow: "none",
  "&:before": { display: "none" },
  backgroundColor: $expanded ? "#36383429" : "transparent",
  transition: "background-color 0.3s ease-in-out",
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  borderRadius: 0,
  position: "relative",
  ...(!$isFirst && {
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 10,
      right: 10,
      height: 1,
      background: "#ddd",
    },
  }),
}));

export const StyledAccordionSummary = styled(AccordionSummary)({
  padding: "8px 0",
  minHeight: "unset",
  "& .MuiAccordionSummary-content": { margin: 0 },
});

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: 0,
}));

export const LessonItemBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$active" && prop !== "$isLast",
})(({ theme, $active, $isLast }) => ({
  display: "flex",
  gap: theme.spacing(1),
  padding: "6px 10px",
  backgroundColor: $active ? "#36383429" : "transparent",
  borderBottom: $isLast ? "none" : "1px solid #ccc",

  "&:hover": {
    cursor: "pointer",
    textDecoration: "underline",
  },
}));

export const LessonNumberText = styled(Typography)({
  fontWeight: "bold",
  minWidth: "60px",
});

export const LessonHeadingText = styled(Typography)({
  flex: 1,
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 2,
  overflow: "hidden",
});
